module.exports = __webpack_public_path__ + "static/img/yj-dispatch.d478a34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/yj-dispatch.svg
// module id = BNVy
// module chunks = 17